export class PackagesDAO {
    constructor(RESOURCE, ArtifactoryDaoFactory) {
        let path  = `${RESOURCE.API_URL}/v1/native`;
        return ArtifactoryDaoFactory()
                .setPath(path)
                .setCustomActions({
                    'showExtraInfo': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/packages/show_extra_info`,
                    },
                    'getPackages': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/packages/:packageType`,
                    },
                    'getPackagesCount': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/packages/:packageType/count_packages`,
                        params: {
                            packageType: '@packageType',
                        },
                    },
                    'getRepos': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/repos/:packageType`,
                        params: {
                            packageType: '@packageType',
                        },
                    },
                    'getPackage': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/versions/:packageType`,
                        params: {
                            packageType: '@packageType',
                        }
                    },
                    'getPackageSummary': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/packages/:packageType/summary`,
                        params: {
                            packageType: '@packageType',
                        }
                    },
                    'getPackageSummaryExtraInfo': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/packages/:packageType/summary/extra_info`,
                        params: {
                            packageType: '@packageType',
                        }
                    },
                    'getPackageDownloadsCount': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/packages/:packageType/total_downloads`,
                        params: {
                            packageType: '@packageType'
                        }
                    },
                    'getDockerPackageExtraInfo': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/packages/:packageType/extra_info`,
                        params: {
                            packageType: '@packageType'
                        }
                    },
                    'getPackageExtraInfo': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/packages/:packageType/extra_info`,
                        params: {
                            packageType: '@packageType'
                        },
                        cancellable: true
                    },
                    'getVersionDownloadsCount': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/versions/:packageType/total_downloads/:repo`,
                        params: {
                            packageType: '@packageType',
	                        repo: '@repo'
                        }
                    },
                    'getVersion': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/versions/:packageType/:repo`,
                        params: {
                            packageType: '@packageType',
                            repo: '@repo'
                        },
                        urlOptions: {encodeUri: false}
                    },
                    'getVersionData': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/versions/:packageType/:dataType`,
                        params: {
                            packageType: '@packageType',
                            dataType: '@dataType'
                        }
                    },
                    'getVersionExtraInfo': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/versions/:packageType/extra_info`,
                        params: {
                            packageType: '@packageType'
                        },
                        cancellable: true
                    },
                    'getVersionSummary': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/versions/:packageType/summary`,
                        params: {
                            packageType: '@packageType',
                        }
                    },
                    'getVersionSummaryExtraInfo': {
                        method: 'POST',
                        notifications: false,
                        url: `${path}/versions/:packageType/summary/extra_info`,
                        params: {
                            packageType: '@packageType',
                        }
                    },
                    'getManifest': {
                        method: 'GET',
                        notifications: false,
                        url: `${path}/versions/:packageType/:repo`,
                        params: {
                            packageType: '@packageType',
                            repoKey: '@repo'
                        },
                    }
                })
                .getInstance();
    }
}




// WEBPACK FOOTER //
// ./data/dao/packages_dao.js